<template>
    <div v-if="loadingGlossary">
        <spinner />
    </div>
    <div v-else-if="definition">
        <label class="ux-field-title" v-if="showLabel">{{label}} <span class="ux-required-marker" v-if="required">*</span></label>
        <div class="ux-field-description" v-if="showDescription">{{description}}</div>
        <div v-if="multiValue">
            This field can not be used on a multiple
        </div>
        <template v-else>
            <div class="field-row" :class="{active:model.enabled[field.path]}" v-for="field in fields">
                <flex-row gap>
                    <flex-cell shrink @click="toggle(field.path)">
                        <ux-checkbox :value="model.enabled[field.path]" />
                    </flex-cell>
                    <flex-cell shrink style="width:200px;">
                        <strong>{{field.filterTitle || field.title}}</strong>
                    </flex-cell>
                    <flex-cell>
                        <template v-if="model.enabled[field.path]">
                            <ux-form v-model="model.updates[field.path]" :fields="[field]" />
                        </template>
                    </flex-cell>
                    <flex-cell shrink style="width:200px;">
                        <template v-if="model.enabled[field.path] && field.maximum != 1">
                            <ux-form v-model="model.updates[field.path]" :fields="mergeFields" />
                        </template>
                    </flex-cell>
                </flex-row>
            </div>
        </template>
    </div>
</template>
<script>
import InputMixin from './input-mixin';
import UxCheckbox from '../../ui/checkbox.vue'

export default {
    components: {
        UxCheckbox,
    },
    props: {
        modelValue: {
            type: Object,
        },
    },
    data() {
        return {
            glossary: null,
            update: 0,
            loadingGlossary: true,
        }
    },
    mixins: [InputMixin],
    watch: {
        'field.referenceType':{
            handler() {
                this.model = {};
                console.log('Reset model')
            }

        },
        model: {
            immediate: true,
            deep: true,
            handler(m) {

                if (!m.enabled) {
                    m.enabled = {}
                }

                if (!m.updates) {
                    m.updates = {}
                }

                this.$emit('update:modelValue', m);
            }

        }
    },
    async created() {
        this.glossary = await this.$sdk.content.glossary({ hash: true });
        this.loadingGlossary = false;
    },
    computed: {
        definition() {

            const referenceType = this.field.referenceType;

            if (!referenceType) {
                return;
            }

            return (this.glossary || {})[referenceType];
        },
        enabledFields() {
            const self = this;

            return self.fields.filter(function(field) {
                return self.model.enabled[field.path];
            });
        },
        mergeFields() {
            const self = this;

            const fields = [];


            fields.push({
                title: 'Merge behavior',
                description: 'As this field can have multiple answers, how would you like to update any existing values?',
                key: 'merge',
                minimum: 1,
                maximum: 1,
                defaultValues: ['add'],
                widget: 'select',
                type: 'string',
                options: [{
                    title: 'Replace existing values',
                    value: 'replace',
                }, {
                    title: 'Add to existing values',
                    value: 'add',
                }, {
                    title: 'Remove from existing values',
                    value: 'remove',
                }],
            })

            return fields;
        },
        fields() {

            const self = this
            const isFormSubmission = self.definition.definesType === 'submission';
            var allFields = [...self.definition.fields];
            var definedFields = (self.definition.definedFields || []).map(function(field) {
                field = { ...field };
                field.batchEditable = true;
                return field;
            });

            if (definedFields.length) {
                if (isFormSubmission) {
                    var formDataFields = {
                        title: `Form Data`,
                        minimum: 1,
                        maximum: 1,
                        key: 'formData',
                        asObject: true,
                        type: 'group',
                        fields: definedFields,
                    }

                    allFields.push(formDataFields);

                    const cleanedDataFields = definedFields.map(function(field) {
                        if (field.type === 'reference') {
                            field = JSON.parse(JSON.stringify(field))
                            delete field.fields;
                        }

                        return field;
                    });

                    var dataFields = {
                        title: `Data`,
                        minimum: 1,
                        maximum: 1,
                        key: 'data',
                        asObject: true,
                        type: 'group',
                        fields: cleanedDataFields,
                    }

                    allFields.push(dataFields);


                } else {

                    var dataFields = {
                        title: `${self.definition.title}`,
                        minimum: 1,
                        maximum: 1,
                        key: 'data',
                        asObject: true,
                        type: 'group',
                        fields: definedFields,
                    }

                    allFields.push(dataFields);

                }
            }


            var mapped = self.$sdk.utils.mapFields(allFields)
                .filter(function(field) {
                    var isObject = field.type == 'group' && field.asObject && (field.minimum == 1 && field.maximum == 1);
                    return !isObject;
                })
                .filter(function(field) {
                    if(field.trail[0] === 'fields') {
                        return false;
                    }

                    if(field.readOnly) {
                        return false;
                    }

                    return (field.batchEditable != false);
                })
                .map(function(field) {
                    field.title = (field.titles).filter(Boolean).join(' › ');
                    field.key = 'value';
                    return field;
                })
                .sort(function(a, b) {
                    const aTitle = a.filterTitle || a.title;
                    const bTitle = b.filterTitle || b.title;
                    return aTitle < bTitle ? -1 : 1;
                });

            return mapped;
        },
    },
    methods: {
        toggle(path) {
            this.model.enabled[path] = !this.model.enabled[path];
            this.update++;
        },
        getNewDefaultEntry() {
            return {
                enabled: {},
                update: {},
            };
        },
    },
}
</script>
<style lang="scss" scoped>
pre {
    border-radius: 0.5em;
    background: #222;
    font-size: 0.8em;
    color: #ddd;
    padding: 1em;
    display: block;
}


.field-row {
    border-top:1px solid rgba(#555, 0.1);
    padding: 0.5em;
    font-size: 0.8em;
    opacity:0.3;
    &:nth-child(even) {
        background: color-mix(in lab, var(--bg2), transparent);
    }
    

    :deep(.ux-field-title) {
        margin-top:0 !important;
    }

    &.active {
        opacity: 1;
    }
}
</style>